
import "./styles.css";
import Weather from "./Weather.js";

export default function App() {
  return (
    <div className="App">
<Weather primaryCity="New York"/>
<br/>
<br/>
</div>
  );
}